import Enum from "../../../../../enums/Enum";

const TypeEnum = new Enum({
        FINAL: {name: "Final"},
        DIFFERENTIAL1: {name: "Differential 1"},
        DIFFERENTIAL2: {name: "Differential 2"},
        PROVISIONAL: {name: "Provisional"}
});

export default TypeEnum;